export default {
  engagement: {
    viewTitle: "Engagement",
    tabTitle: "Engagement",
  },
};
